import "./style.css"
import "@fortawesome/fontawesome-free/css/all.css"
import {ofetch} from "ofetch"

document.getElementById("navbar-mobile-button")?.addEventListener("click", () => {
    document.getElementById("navbar-menu")?.classList.toggle("hidden");
});

document.getElementById('force-broe2')?.addEventListener("click", async () => {
    await ofetch("/admin/forceupdate").then(() => {
        alert("This has been queued and will complete shortly.")
    });
});

function setupDelete(buttonClass: string, deleteUrl: string) {
    const deleteButtons = document.getElementsByClassName(buttonClass);
    for (let deleteButton of deleteButtons) {
        deleteButton.addEventListener("click", async () => {
            if (deleteButton.getAttribute("data-checked") == "false") {
                deleteButton.setAttribute("data-checked", "true");
                deleteButton.innerHTML = "Sure <i class=\"fa-solid fa-question\"></i>";
                deleteButton.classList.remove("bg-client-red");
                deleteButton.classList.remove("text-white");
                deleteButton.classList.add("border-client-red");
                deleteButton.classList.add("text-black");
            } else {
                await ofetch(deleteUrl + deleteButton.getAttribute("data-id"))
                    .catch(() => alert("Issue deleting")).then(() => {
                        deleteButton.closest("tr")?.remove();
                    });
            }
        });
    }
}
setupDelete("delete-competition", "competitions/delete?id=");
setupDelete("delete-meeting", "meetings/delete?id=");
